import { Helmet } from "react-helmet-async"
import { Container } from "@sembark-travel/ui-base"
import { ActivityVoucherTemplates } from "../../../../../EmailPdfTemplates"

export default function OrganizationActivityVoucherTemplatesPage() {
	return (
		<>
			<Helmet>
				<title>Activity Voucher</title>
			</Helmet>
			<Container paddingY="4">
				<ActivityVoucherTemplates />
			</Container>
		</>
	)
}
